export default {
  helpCenter: 'Help Center',
  'helpCenter.customerService': 'Customer Service',

  'helpCenter.lastUpdates': 'Last Updates',
};
